import API from "./API";
import Alert from "../stores/alerts";
import app from "../stores/app";
import user from "../stores/user";
import {writable} from "svelte/store";

export const LOADER = {
    NONE: 0,
    PAGE: 1,
    POPUP: 2,
}

const mm = writable(false);

const R = {
    handle: async (func, params, success, failure, loader = 0) => {
        if (loader == LOADER.PAGE) {
            app.showPageLoader();
        } else if (loader == LOADER.POPUP) {
            app.showPopupLoader();
        }

        mm.set(true);
        //const [err, result] = await func(params);
        const result = await func(params);
        mm.set(false);

        if (loader == LOADER.PAGE) {
            app.hidePageLoader();
        } else if (loader == LOADER.POPUP) {
            app.hidePopupLoader();
        }

        if (result.error) {
            if (result.error.code == 'no_login') {
                Alert.warning("Λογαριασμός", "Έχεις αποσυνδεθεί από τον λογαριασμό σου!");
                user.clearToken();
            }
            failure(result.error);
        } else {
            success(result.data);
        }
    },

    app: {
        login: (data) => API.POST(`login`, data),
        initialize: () => API.GET('initialize'),
    },

    user: {
        index: (data) => API.POST('users', data),
        initialize: (id) => API.GET(`user/${id}/initialize`),
        details: (id) => API.GET(`user/${id}/details`),
        create: (data) => API.POST('user/create', data),
        edit: (data) => API.POST(`user/edit`, data),
        delete: (id) => API.POST('user/delete', {id}),
    },

    hotel: {
        index: (data) => API.POST('hotels', data),
        details: (id) => API.GET(`hotel/${id}/details`),
        create: (data) => API.POST('hotel/create', data),
        edit: (data) => API.POST(`hotel/edit`, data),
        delete: (id) => API.POST('hotel/delete', {id}),
    },

    member: {
        index: (data) => API.POST('members', data),
        details: (id) => API.GET(`member/${id}/details`),
        create: (data) => API.POST('member/create', data),
        edit: (data) => API.POST(`member/edit`, data),
        delete: (id) => API.POST('member/delete', {id}),

        log: (id) => API.GET(`member/${id}/log`),

        points: (id) => API.GET(`member/${id}/points`),
        addPoints: (data) => API.POST(`member/add-points`, data),
        removePoints: (data) => API.POST(`member/remove-points`, data),
        transferPoints: (data) => API.POST(`member/transfer-points`, data),
        deletePoints: (id) => API.POST(`member/delete-points`, {id}),
    },

    checkin: {
        index: (data) => API.POST('checkins', data),
        request: (hash) => API.POST('checkin/request', {hash}),
        confirm: (data) => API.POST('checkin/confirm', data),
        refuse: (hash) => API.POST('checkin/refuse', {hash}),
        details: (id) => API.GET(`checkin/${id}/details`),
        edit: (data) => API.POST(`checkin/edit`, data),
        delete: (id) => API.POST('checkin/delete', {id}),
    },

    teatro: {
        index: (data) => API.POST('teatro-passes', data),
        details: (id) => API.GET(`teatro-pass/${id}/details`),
        create: (data) => API.POST('teatro-pass/create', data),
        edit: (data) => API.POST(`teatro-pass/edit`, data),
        delete: (id) => API.POST('teatro-pass/delete', {id}),
    },

    actionRequests: {
        index: (data) => API.POST('action-requests', data),
    },

    settings: {
        details: () => API.GET(`settings/details`),
        edit: (data) => API.POST(`settings/edit`, data),
    },
};

export default R;
export {mm as requestingStore};